import { render, staticRenderFns } from "./StorageUser.vue?vue&type=template&id=b9cdf62a&"
import script from "./StorageUser.vue?vue&type=script&lang=js&"
export * from "./StorageUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports